/* eslint
  prefer-const: 0,
  react/prop-types: 0,
  react/jsx-no-bind: 0
*/
import React from 'react';

import CargomaticCard from 'components/v2/card';
import ChevronUp from 'components/v2/icons/ChevronUpIcon';
import ChevronDown from 'components/v2/icons/ChevronDownIcon';
import { withTranslation } from 'react-i18next';
import DownloadPDFButton, {
  CarrierPayoutNumberCell,
  DateCell,
  PayoutStatusCell,
  MoneyCell,
  RawCell,
} from '../renderer';
import { headersByFieldNames } from './mappings';
import DownloadIcon from 'components/v2/icons/DownloadIcon';

function renderRow(payout) {
  const { shipmentIds, items } = payout;
  return (
    <tr data-id={payout._id} key={payout._id}>
      <CarrierPayoutNumberCell data={payout} />
      <RawCell
        className="truncate"
        data={shipmentIds.map((id) => (
          <>
            {id}
            <br />
          </>
        ))}
      />
      <RawCell
        className="truncate"
        data={
          items.length &&
          items.map((item) => (
            <>
              {item}
              <br />
            </>
          ))
        }
      />
      <DateCell data={payout.date_created} />
      <DateCell data={payout.due_date} />
      <MoneyCell data={payout.total} currency={payout?.currency} />
      <PayoutStatusCell data={payout.status} />
      <td>
        <DownloadPDFButton payout={payout} />
      </td>
    </tr>
  );
}

class PayoutList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: {
        key: props.sort.key,
        order: props.sort.order,
      },
    };
  }

  onHeaderClick(key) {
    const state = Object.assign({}, this.state);
    if (key === this.state.sort.key) {
      state.sort.order = state.sort.order === 'asc' ? 'desc' : 'asc';
    } else {
      state.sort = {
        key,
        order: 'asc',
      };
    }
    this.props.onSortChange(state.sort);
    this.setState(state);
  }

  renderHeaders() {
    const { t } = this.props;

    return (
      <tr className="">
        {Object.keys(headersByFieldNames).map((key) => {
          const icon =
            this.state.sort.order === 'asc' ? <ChevronDown /> : <ChevronUp />;

          let thClassNames = [''];
          let sortArrow = '';
          if (key === this.state.sort.key) {
            thClassNames.push('current-sort');
            sortArrow = <div className="cursor-pointer">{icon}</div>;
          }

          return (
            <th
              data-key={key}
              key={key}
              onClick={this.onHeaderClick.bind(this, key)}
              className={thClassNames.join(' ')}
            >
              <div className="flex items-center min-h-6 space-x-1">
                <span>{t(headersByFieldNames[key])}</span>
                {sortArrow}
              </div>
            </th>
          );
        })}
      </tr>
    );
  }

  renderInfo() {
    const { t } = this.props;
    return (
      <div className="flex justify-between items-center">
        <h3 className="">{t('PAYOUT', { count: 1 })}</h3>
        <button
          title={t('EXPORT_CSV')}
          className="flex item-center button button-hollow-green"
          onClick={this.props.handleDownloadCSVReport}
        >
          {t('EXPORT_CSV')}
          <DownloadIcon />
        </button>
      </div>
    );
  }

  render() {
    const { t } = this.props;
    const rows = this.props.payouts.map((payout) => renderRow(payout));

    return (
      <div className="mx-auto max-w-screen-2xl my-8 sm:my-32 xl:my-8">
        <CargomaticCard header={() => this.renderInfo()}>
          <div className="card--no-x-padding card--no-top-padding -mb-4 sm:-mb-4">
            <table className="default-table">
              <thead>{this.renderHeaders()}</thead>
              <tbody>{rows}</tbody>
            </table>
          </div>
        </CargomaticCard>
      </div>
    );
  }
}

export default withTranslation()(PayoutList);
